import React from "react";
import dynamic from 'next/dynamic';
import {Card, Space, Select} from "antd";
import style from "./chartCountries.module.scss";
import {useTranslations} from "next-intl";

const Bar = dynamic(() => import('@ant-design/plots').then(({ Bar }) => Bar),
    { ssr: false }
);

export const CountriesChart = ({info, onChangeFilter}) => {
    const t = useTranslations('dashboard');
    const config = {
        data: info ? info.sort((a, b) => b.value - a.value) : [],
        xField: 'country',
        yField: 'value',
        sort: {
            reverse: true,
        },
        legend: false,
        colorField: 'country',
        scale: { color: { range: ['#C97474', '#C95F5F', '#DD8080', '#884D4D', '#9E3636', '#7D1F1F', '#C12E2E', '#9B2525', '#B47C7C', '#9A5151'] } },
        height: 365,
        maxWidth: 910,
    };

    const types = [
        {
            id: 'all',
            value: t('all_type')
        },
        {
            id: 'entrepreneur',
            value: t('entrepreneur')
        },
        {
            id: 'business',
            value: t('business')
        },
        {
            id: 'cargo',
            value: t('cargo')
        },
    ];

    return (
        <>
            <div className={style.block}>
                <Card
                    title={t('top_countries')}
                    className={'charts'}
                    extra={(
                        <Space>
                            <Select
                                style={{width: '168px'}}
                                className='primary'
                                defaultValue={'all'}
                                options={types}
                                fieldNames={{ value: 'id', label: 'value' }}
                                onChange={(value) => onChangeFilter('type', value)}
                            />
                        </Space>
                    )}
                >
                    {info && info.length ?
                        <Bar {...config} /> :
                        <div className={style.not_found}>{t('not_found')}</div>
                    }
                </Card>
            </div>
        </>
    );
}